module.exports = __webpack_public_path__ + "img/grid-3x2.c003d776.svg";